import AppSettings from '../../../core/AppSettings';
import axios from 'axios';
/*
* summons ye ole eSpot data array
* */
export const getErrorPageData = ()=>{
  const url = "/wcs/resources/store/" + AppSettings.storeId + "/espot/ErrorPageImage_Content";
  return axios.get(url).then(response=>response.data).catch(error=>console.log('X_X GET ERROR PAGE DATA ERROR X_X', error));
};
